import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-paper-calculator', function (calculator) {
        let c1SumaKG = 0,
            c2SumaARK = 0,
            c3SumaPLNARK = 0,
            c4SumaPLNKG = 0;

        let calculate = function (e) {
            let getVal = function(id) {
                let el = document.getElementById(id);
                return el ? parseFloat(el.value) : null;
            };

            let c1Gramatura = getVal('uGramatura'),
                c1FormatX = getVal('uFormatX'),
                c1FormatY = getVal('uFormatY'),
                c1IloscArkuszy = getVal('uIloscArkuszy'),
                c2Gramatura = getVal('u2Gramatura'),
                c2FormatX = getVal('u2FormatX'),
                c2FormatY = getVal('u2FormatY'),
                c2IloscKG = getVal('u2IloscKG'),
                c3Gramatura = getVal('u3Gramatura'),
                c3FormatX = getVal('u3FormatX'),
                c3FormatY = getVal('u3FormatY'),
                c3CenaPLNKG = getVal('u3CenaPLNKG'),
                c4Gramatura = getVal('u4Gramatura'),
                c4FormatX = getVal('u4FormatX'),
                c4FormatY = getVal('u4FormatY'),
                c4CenaPLNAR = getVal('u4CenaPLNARK');

            if(c1Gramatura && c1FormatX && c1FormatY && c1IloscArkuszy){
                c1SumaKG = (c1Gramatura/1000) * (c1FormatX/1000) * (c1FormatY/1000) * c1IloscArkuszy;
                let el = document.getElementById('wSumaKG');
                if (el) el.value = c1SumaKG.toFixed(2);
            }

            if(c2Gramatura && c2FormatX && c2FormatY && c2IloscKG){
                c2SumaARK = (c2IloscKG / (c2Gramatura/1000) / (c2FormatX/1000) / (c2FormatY/1000));
                let el = document.getElementById('w2SumaARK');
                if (el) el.value = c2SumaARK.toFixed(0);
            }

            if(c3Gramatura && c3FormatX && c3FormatY && c3CenaPLNKG){
                c3SumaPLNARK = c3CenaPLNKG * (c3Gramatura/1000) * (c3FormatX/1000) * (c3FormatY/1000);
                let el = document.getElementById('w3SumaPLNARK');
                if (el) el.value = c3SumaPLNARK.toFixed(8);
            }

            if(c4Gramatura && c4FormatX && c4FormatY && c4CenaPLNAR){
                c4SumaPLNKG = (c4CenaPLNAR / (c4Gramatura/1000) / (c4FormatX/1000) / (c4FormatY/1000));
                let el = document.getElementById('w4SumaPLNKG');
                if (el) el.value = c4SumaPLNKG.toFixed(8);
            }
        }

        let addListener = function(id, event, callback) {
            let el = document.getElementById(id);
            if (el) {
                el.addEventListener(event, callback);
            }
        };

        addListener('uGramatura', 'input', calculate);
        addListener('uFormatX', 'input', calculate);
        addListener('uFormatY', 'input', calculate);
        addListener('uIloscArkuszy', 'input', calculate);

        addListener('u2Gramatura', 'input', calculate);
        addListener('u2FormatX', 'input', calculate);
        addListener('u2FormatY', 'input', calculate);
        addListener('u2IloscKG', 'input', calculate);

        addListener('u3Gramatura', 'input', calculate);
        addListener('u3FormatX', 'input', calculate);
        addListener('u3FormatY', 'input', calculate);
        addListener('u3CenaPLNKG', 'input', calculate);

        addListener('u4Gramatura', 'input', calculate);
        addListener('u4FormatX', 'input', calculate);
        addListener('u4FormatY', 'input', calculate);
        addListener('u4CenaPLNARK', 'input', calculate);
    });
}